import React from 'react';
import { useHistory } from 'react-router-dom';
import Btn, { btnSizes, btnTypes } from '../../../../components/btn';
import { paths } from '../../shared/configs/routing';

const CancelToDetails = ({ resetFn, disabled }) => {
  const history = useHistory();

  const handleClick = () => {
    const { push, location } = history;
    push(location.state?.from?.location ?? paths.main);
    typeof resetFn === 'function' && resetFn();
  };

  return (
    <Btn
      type={btnTypes.primaryInvert}
      size={btnSizes.lg}
      onClick={handleClick}
      disabled={disabled}
    >
      Отмена
    </Btn>
  );
};

export default CancelToDetails;
